import React from 'react';
import { useDemo } from '../../contexts/DemoContext';
interface Props {
  dark?: boolean;
  showCorrectAction?: boolean;
}
export function ScenarioKeyTable({
  dark = false,
  showCorrectAction = false
}: Props) {
  const {
    bundle
  } = useDemo();
  const headRule = dark ? 'border-white/15' : 'border-rule';
  const rowRule = dark ? 'border-white/10' : 'border-rule/70';
  const headText = dark ? 'text-white/40' : 'text-muted/70';
  const bodyText = dark ? 'text-white/80' : 'text-ink';
  const accent = dark ? 'text-brand-light' : 'text-brand';
  const quiet = dark ? 'text-white/45' : 'text-muted';
  const packText = dark ? 'text-white/50' : 'text-muted';
  const packQuiet = dark ? 'text-white/35' : 'text-muted/70';
  const columns = showCorrectAction ? 5 : 4;
  return <table className="w-full border-collapse text-left" data-id="element-56" data-mp="2usgnd6btr5bf">
      <thead data-id="element-57" data-mp="1ebkt0h0cb94h">
        <tr className={`border-b ${headRule} font-mono-num text-[10px] uppercase tracking-[0.1em] ${headText}`} data-id="element-58" data-mp="1easyl9ihbhfs">
          <th className="w-10 py-2 pr-3 font-medium" data-id="element-59" data-mp="ghn0jvcbolq9">SC</th>
          <th className="w-28 py-2 pr-3 font-medium" data-id="element-60" data-mp="gi53tbxek07o">Class</th>
          <th className="py-2 pr-4 font-medium" data-id="element-61" data-mp="bj1wfkty9hwj">What was planted</th>
          {showCorrectAction && <th className="w-52 py-2 pr-4 font-medium" data-id="element-62" data-mp="qfj687mhqogz">Full-credit action</th>}
          <th className="w-32 py-2 font-medium" data-id="element-63" data-mp="qdgbjaae875x">Revealed by</th>
        </tr>
      </thead>
      <tbody data-id="element-64" data-mp="lisv7ypjmj2f">
        {bundle.assessmentKey.map(row => <tr key={row.sc} className={`border-b ${rowRule} align-top`} data-id="element-65" data-mp="zf6bx5m96gfu">
            <td className={`py-3 pr-3 font-mono-num text-[11.5px] ${quiet}`} data-id="element-66" data-mp="uhxtd3x70ae2">{row.sc}</td>
            <td className={`py-3 pr-3 font-mono-num text-[10.5px] uppercase tracking-[0.08em] ${accent}`} data-id="element-67" data-mp="1960xs8vl7e0r">
              {row.klass}
            </td>
            <td className={`py-3 pr-4 text-[12.5px] leading-relaxed ${bodyText}`} data-id="element-68" data-mp="147pobz97f5j2">{row.planted}</td>
            {showCorrectAction && <td className={`py-3 pr-4 text-[12.5px] leading-relaxed ${quiet}`} data-id="element-69" data-mp="1e5dmkz60qv5z">
                {row.correctAction}
              </td>}
            <td className={`py-3 font-mono-num text-[11px] ${accent}`} data-id="element-70" data-mp="1l9wid9gc72v7">{row.revealedBy}</td>
          </tr>)}
      </tbody>

      <tbody data-id="element-71" data-mp="1q5kbu11uqi6i">
        <tr data-id="element-72" data-mp="1v6rhnukfp7aj">
          <td colSpan={columns} className="pt-7" data-id="element-73" data-mp="1v716hetqt8en">
            <p className={`font-mono-num text-[10px] uppercase tracking-[0.1em] ${headText}`} data-id="element-74" data-mp="1v5genwytc3kh">
              Pack-level items · not scenarios
            </p>
            <p className={`mt-1.5 text-[12px] leading-relaxed ${packQuiet}`} data-id="element-75" data-mp="23zl3kaudz4xd">
              Realistic loose ends. Scored only if the candidate engages with them — restraint is
              the test.
            </p>
          </td>
        </tr>
        {bundle.packLevelItems.map(row => <tr key={row.planted} className={`border-b ${rowRule} align-top`} data-id="element-76" data-mp="2iwvla1xmh71j">
            <td colSpan={2} className={`py-3 pr-3 font-mono-num text-[10.5px] uppercase tracking-[0.08em] ${packQuiet}`} data-id="element-77" data-mp="2itzk84qha28v">
              Pack
            </td>
            <td className={`py-3 pr-4 text-[12.5px] leading-relaxed ${packText}`} data-id="element-78" data-mp="ok5o9bbyjhpx">{row.planted}</td>
            {showCorrectAction && <td className={`py-3 pr-4 text-[12.5px] leading-relaxed ${packQuiet}`} data-id="element-79" data-mp="2x1m7wa6pxil9">
                {row.correctAction}
              </td>}
            <td className={`py-3 font-mono-num text-[11px] ${packQuiet}`} data-id="element-80" data-mp="2sxwi5heb4uyn">{row.revealedBy}</td>
          </tr>)}
      </tbody>
    </table>;
}